module.exports = __webpack_public_path__ + "img/switch-table.aa214d83.svg";